import store from "@/plugins/vuex";
import { CORP_ADMIN, CHANNEL_ADMIN } from '@/helpers/userRoles';

export async function loadUserById({ id }) {
  try {
    const data = await store.dispatch('usersApiStore/fetchUserById', id);

    return { data, success: true }
  } catch (e) {
    return { data: null, success: false };
  }
}

function getRolesWithCorporations(role, corporations) {
  return corporations.map((corporation) => ({
    corporationId: corporation.corporationId || corporation.id,
    name: role,
  }));
}

export function transformerForUserRoles(userRole, roles) {
  const userRoles = userRole === CORP_ADMIN ? getRolesWithCorporations(userRole, roles) : [{ name: userRole }];

  return userRoles;
}

export function userState(payload) {
  const state = {
    ...payload,
    role: payload.roles.length > 0 && payload.roles[0].name === CORP_ADMIN ? CORP_ADMIN : CHANNEL_ADMIN,
  };

  function patchField(field, value) {
    if (Array.isArray(state[field])) {
      state[field].push(value);
      return;
    }

    state[field] = value;
  }

  function resetState() {
    state.user = {};
  }

  function removeRole(id) {
    state.roles = state.roles.filter(role => role.corporationId !== id);
  }

  function isRoleAdded(id) {
    return state.roles.some(role => role.corporationId === id);
  }

  return {
    state,
    patchField,
    resetState,
    removeRole,
    isRoleAdded,
  }
}